export default __webpack_public_path__ + "static/media/659.0834565a.png";